// extracted by css-extract-rspack-plugin
export default {"cls1":"Base-cls1_M6d","cls2":"Base-cls2_gs0 Base-cls1_M6d"};